import Papa from 'papaparse';
import { CampaignPost } from '../types/calendar';

export function parseCSVContent(csvText: string): CampaignPost[] {
  const result = Papa.parse<Record<string, string>>(csvText, {
    header: true,
    skipEmptyLines: true,
    transformHeader: (header) => header.trim(),
  });

  if (result.errors && result.errors.length > 0) {
    console.warn('CSV Parsing warnings/errors:', result.errors);
  }

  const posts: CampaignPost[] = result.data.map((row, index) => {
    // Normalize keys regardless of minor spacing differences
    const getVal = (...keys: string[]): string => {
      for (const k of keys) {
        if (row[k] !== undefined && row[k] !== null) return row[k].trim();
        // check case-insensitive match
        const foundKey = Object.keys(row).find(rk => rk.toLowerCase() === k.toLowerCase());
        if (foundKey && row[foundKey] !== undefined) return row[foundKey].trim();
      }
      return '';
    };

    const postId = getVal('Post ID', 'postId', 'ID') || `P${String(index + 1).padStart(3, '0')}`;
    const dateStr = getVal('Date', 'date');
    const day = getVal('Day', 'day');
    const week = getVal('Week', 'week');
    const phase = getVal('Phase', 'phase');
    const platform = getVal('Platform', 'platform');
    const contentPillar = getVal('Content Pillar', 'contentPillar', 'Pillar');
    const format = getVal('Format', 'format');
    const contentToCreate = getVal('Content to Create', 'contentToCreate');
    const hook = getVal('Hook', 'hook');
    const caption = getVal('Caption', 'caption');
    const hashtags = getVal('Hashtags/Keywords', 'hashtags', 'Hashtags', 'Keywords');
    const visualDirection = getVal('Visual & Asset Direction', 'visualDirection', 'Visual Direction');
    const cta = getVal('CTA', 'cta');
    const link = getVal('Link', 'link');
    const status = getVal('Status', 'status') || 'Idea';
    const notes = getVal('Notes', 'notes');

    let rawDate: Date | null = null;
    if (dateStr) {
      const parsed = new Date(dateStr);
      if (!isNaN(parsed.getTime())) {
        rawDate = parsed;
      }
    }

    return {
      postId,
      date: dateStr,
      day,
      week,
      phase,
      platform,
      contentPillar,
      format,
      contentToCreate,
      hook,
      caption,
      hashtags,
      visualDirection,
      cta,
      link,
      status,
      notes,
      rawDate,
    };
  });

  return posts.filter(p => p.postId || p.date || p.platform || p.caption);
}

export function exportToCSV(posts: CampaignPost[]): string {
  const data = posts.map(p => ({
    'Post ID': p.postId,
    'Date': p.date,
    'Day': p.day,
    'Week': p.week,
    'Phase': p.phase,
    'Platform': p.platform,
    'Content Pillar': p.contentPillar,
    'Format': p.format,
    'Content to Create': p.contentToCreate,
    'Hook': p.hook,
    'Caption': p.caption,
    'Hashtags/Keywords': p.hashtags,
    'Visual & Asset Direction': p.visualDirection,
    'CTA': p.cta,
    'Link': p.link,
    'Status': p.status,
    'Notes': p.notes,
  }));

  return Papa.unparse(data);
}
